import React, { useEffect } from 'react'
import { useLocation } from '@tanstack/react-router'
import { useCart } from '@/components/cart/hooks/useCart';
import { SaleType, ScanForm } from '@/components/cart/hooks/useValidateOrder';


interface Props {
  children: React.ReactNode;
}

const AppScanFromProvider: React.FC<Props> = ({ children }) => {
  const searchStr = useLocation({ select: (location) => location.searchStr })

  const { updateCore } = useCart()

  const scanFrom = new URLSearchParams(searchStr).get('scan_from')

  useEffect(() => {
    if (scanFrom) {
      updateCore({
        scan_from: scanFrom as ScanForm,
        saleType: SaleType.DineIn
      })
    } else {
      updateCore({
        scan_from: null,
      })
    }
  }, [])

  return (
    <>
      {children}
    </>
  )
}

export default AppScanFromProvider
